/**
 * Newsletter subscription service for waitlist
 */

// MailerLite configuration
const MAILERLITE_API_URL = 'https://connect.mailerlite.com/api';
const MAILERLITE_API_KEY = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0IiwianRpIjoiZWM0NDljZGIxMGFmZDA5Mjk0YzgxZjY1MDQwMzhhYzBiMjA2YmMyNWY0ZDhkNjFjNjE2ZGJiMDU1YjM2OTViNDJlZmUzMTFmNGVlN2NjMDgiLCJpYXQiOjE3NDYwMjQ5NTkuNzEzODk4LCJuYmYiOjE3NDYwMjQ5NTkuNzEzOSwiZXhwIjo0OTAxNjk4NTU5LjcwOTc4Miwic3ViIjoiMTUwMjE3NCIsInNjb3BlcyI6W119.SZ0Oz3HfCJWzZD3_PF2ICCZZVx6o0ntxl0WVYwbn_pJW-xTFWu5jNoYupzG_xVfRTcT0AS9WgHISlLXZLCsUO2WnOVd9lzzhD-68WGpplJifTuWZxdYy2ORFeloZkQvaROC34hgpqeHFeuKLlL66VFDsRLrB2h3OACMft6m4OOuUCiwrbU1yoQinmEVxuNlNhLZ27FX3AHaVxM2La3hbq3M7zn_qjOEN7ZT-D7jim0I-6cAWdcMQdW6FHYyZCnmF3NGa73-W2B5LkDdw5ilMlVTUqR1wI330LfhUL1bdHeIzYBS16w3CsjZB-FySX95upq0OpF5_nNKLyrR3iuCbiUyIeZt2szCUX5rVFktbObCaWPxpUVv2ICa77uGxvmqloM4Agqy_m_P3d8oIoKPwZeGEEwHcpxTQ-9siuPykz6YoXnk2hKPSnDlsKaHzz5ltbmNX6XhVo1QHbXgP3fefs_wwFl76KeHaCKIRxeBstfy1NpGCKiWNzpD1eQI-tgGGcOBGDVQ5Gmyq52OaOo1DlCtU9OXIJVxo6YTSiFXANBSdLwnXByY30JY-PV79j3ZKWW-iQx4IKXFo5wXcdAdmj2cABpuOyVf3IXk5EkSg5zkvhFL9tE_tedb5xpWIC42cO-YYjXKfyRG8P2V2DxTyQUTjEJowyo6Iaj0KLuQa76I';

// Ummahti Newsletter Group ID
const NEWSLETTER_GROUP_ID = '153118187133601526';

/**
 * Subscribe email to waitlist/newsletter
 * @param {string} email - The email address to subscribe
 * @param {Object} options - Optional parameters
 * @returns {Promise<Object>} - The subscription result
 */
export const subscribeToWaitlist = async (email, options = {}) => {
  try {
    if (!email) {
      throw new Error('Email is required');
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      throw new Error('Please enter a valid email address');
    }

    const response = await fetch(`${MAILERLITE_API_URL}/subscribers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${MAILERLITE_API_KEY}`
      },
      body: JSON.stringify({
        email,
        fields: {
          name: options.name || '',
          source: 'website_smart_clock_waitlist',
          product_interest: 'smart_adhan_clock',
          ...options.fields
        },
        groups: [NEWSLETTER_GROUP_ID]
      })
    });

    if (!response.ok) {
      const errorData = await response.json();

      // Handle specific error cases
      if (response.status === 422) {
        // Email already exists - this is actually a success case for waitlist
        if (errorData.message && errorData.message.includes('already')) {
          return {
            success: true,
            alreadySubscribed: true,
            message: "You're already on our waitlist! We'll notify you as soon as the Smart Adhan Clock is available."
          };
        }
      }

      throw new Error(errorData.message || 'Failed to join waitlist');
    }

    const data = await response.json();
    return {
      success: true,
      data,
      message: "Success! You're on the waitlist for the Smart Adhan Clock."
    };
  } catch (error) {
    console.error('Waitlist subscription error:', error);

    // Provide user-friendly error messages
    let userMessage = 'Something went wrong. Please try again later.';

    if (error.message.includes('Email is required')) {
      userMessage = 'Please enter your email address';
    } else if (error.message.includes('valid email')) {
      userMessage = 'Please enter a valid email address';
    } else if (error.message.includes('network') || error.message.includes('fetch')) {
      userMessage = 'Connection error. Please check your internet and try again.';
    }

    return {
      success: false,
      error: userMessage,
      technicalError: error.message
    };
  }
};
